module.exports = __webpack_public_path__ + "static/media/HistoryColoredIcon.8a80da2b.svg";